"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = exports.getColor = exports.getLargeBorderRadius = exports.getBorderRadius = exports.getSize = exports.sizeToNumber = void 0;

var case_1 = __importDefault(require("case"));

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var log_1 = require("./log");

function isNativeTheme(theme) {
  return typeof theme.size === 'object';
}

function convertSizeToNativeTheme(size) {
  return size.replace('@size-', '');
}

function sizeToNumber(size) {
  return parseFloat(size.replace('px', ''));
}

exports.sizeToNumber = sizeToNumber;

function convertColorToNativeTheme(color) {
  if (color === '@primary-color') return 'primary';
  if (color === '@primary-color-light') return 'primaryLight';
  if (color === '@text-color-secondary') return 'textSecondary';
  if (color === '@border-color-base') return 'borderColor';
  return case_1.default.camel(color.replace('@', ''));
}
/**
 * Given a theme and a web-theme size name, gets the proper size depending
 * on if the passed theme is a web theme or a native theme.
 */


function getSize(theme, size) {
  if (size === '@border-radius-base') {
    return getBorderRadius(theme);
  } else if (size === '@border-radius-large') {
    return getLargeBorderRadius(theme);
  }

  return isNativeTheme(theme) ? theme.size[convertSizeToNativeTheme(size)] : theme[size];
}

exports.getSize = getSize;
/**
 * Gets the border radius size from the passed theme.
 */

function getBorderRadius(theme) {
  return isNativeTheme(theme) ? theme.borderRadius : theme['@border-radius-base'];
}

exports.getBorderRadius = getBorderRadius;
/**
 * Gets the large border radius size from the passed theme.
 */

function getLargeBorderRadius(theme) {
  return isNativeTheme(theme) ? theme.borderRadiusLarge : theme['@border-radius-large'];
}

exports.getLargeBorderRadius = getLargeBorderRadius;
/**
 * Given a theme and a web-theme color name, gets the proper color depending
 * on if the passed theme is a web theme or a native theme.
 */

function getColor(theme, color, _suppress) {
  if (isNativeTheme(theme)) {
    var colorName = convertColorToNativeTheme(color);

    if (!theme.colors[colorName] && !_suppress) {
      (0, log_1.warn)('color %s does not exist in native theme', colorName);
    }

    return theme.colors[colorName];
  } else {
    return theme[color];
  }
}

exports.getColor = getColor;
/** Gets the current styled components theme. */

function useTheme() {
  return react_1.default.useContext(styled_components_1.ThemeContext);
}

exports.useTheme = useTheme;